import sigliveServiceV3 from 'Service/sigliveServiceV3';

const deleteTarget = async ({ id }) => {
  const { data } = await sigliveServiceV3({ method: 'DELETE', url: `/target/${id}` });

  return data;
};

export default deleteTarget;
